import React from 'react'

import clsx from 'clsx'

import Review from 'components/Review'

import RatingBreakdownDisplay from '../BreakdownDisplay'

import classes from './StarBreakdown.module.scss'

const ReviewStarBreakdown = ({
  className,
  href,
  ratingAvg,
  reviewsByRating,
  totalNumberOfReviews,
  variant = 'large',
}) => {
  return (
    <div className={clsx('StarBreakdown', classes[variant], classes.root, className)}>
      <Review.Display
        className={classes.reviewDisplay}
        href={href}
        rating={ratingAvg}
        reviewsNumber={totalNumberOfReviews}
        variant="small"
        subscript=""
      />
      <RatingBreakdownDisplay reviewsByRating={reviewsByRating} />
    </div>
  )
}

export default ReviewStarBreakdown
